export default __webpack_public_path__ + "static/media/pylek.57d37193.svg";